import React, { useRef, useEffect, useState } from "react";
import {Button,Dropdown,TextArea,TextInput,Modal,Notification,Search,TabsNavigation,Tab,Switcher} from "pepsico-ds";
import Tooltip from "./tooltip.jsx";
import { Controller, useForm } from "react-hook-form";
import { toast,ToastContainer  } from 'react-toastify';
import axios from "axios";
import "../requests/requests.css";
import "./myidm.css";
import { useLoading } from "../../loader";
import { useNavigate } from "react-router-dom";
import requestsService from "../requests/requestsservice";
import { useTranslation } from "react-i18next";

const ArfFormAttributes = ({selectedId,setSelectRequest,modeType,uid,setSelectedId}) => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const navigate = useNavigate();
  const [copyButtonText, setCopyButtonText] = useState("Copy");
  const [requestNumber, setRequestNumber] = useState("");
  // const { register, control, handleSubmit, formState: { errors } } = useForm({ mode: "onBlur", reValidateMode: "onChange" });
  const [attributes, setAttributes] = useState([]);
  const { showLoader, hideLoader } = useLoading();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [formKey, setFormKey] = useState(0);
  const [formRequestSuccess, setFormRequestSuccess] = useState(false);
  const [formData, setFormData] = useState({});
  const [gpid, setGpid] = useState("");
  // const [tabErrors, setTabErrors] = useState({});
  const [reqGpid,setReqGpid] = useState("");
  const [showNotification, setShowNotification] = useState(true);
  const [successfulRequestsList,setSuccessfulRequestsList] =useState([]);
  const [selectedRightTabIndex, setSelectedRightTabIndex] = useState(0);
  const { t } = useTranslation();
  const [pendingFieldChange, setPendingFieldChange] = useState(null);
  const notificationRef = useRef(null);
  const [formObjecct, setFormObject] = useState({
    appName: "Spaceman",
    appId: "1230001000",
    triggeringField: "onload",
    stage: "0",
    requestType: "NEW",
    requestedForGpid: gpid,
    requestedByGpid: gpid,
    pepManager: "10000836",
    lang: "en",
    form: {},
    isOnChange: false,
  });
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    getValues,
    setValue,
    reset,
    unregister
  } = useForm({
    mode: "onBlur",
    // defaultValues: attributes?.reduce((acc, attr) => {
    //   acc[attr.attribute_id.toString()] =
    //     attr.attribute_type === "multiselect" ? [] : "";
    //   return acc;
    // }, {}),
  });
  function gotoHomePage() {
    navigate("/home");
  }
  const gotoRequestAuditPage = () =>{
    let statePayload = {};
    if (requestNumber) {
      let firstRequestNumber = requestNumber;
      // Check if requestNumber is contains a comma
      // if (requestNumber.includes(',')) {
      //   firstRequestNumber = requestNumber.split(',')[0].trim();
      // }
      statePayload = { type: "gpid", value: reqGpid ? reqGpid : gpid };
      navigate("/audit-requests", { state: statePayload });
    }
  }
  const gotoRequestPage =()=>{
    
    if(uid == gpid){
      if(selectedId[selectedIndex].requestType == 'NEW'){
        navigate('/request-access');
      }
      else{
        navigate('home')
      }
    }
    else if(reqGpid){
    navigate('/myidmPortal', { state: {navigateFrom: 'request_access_others'} })
  }
  }
  const [selectedIndex, setSelectedIndex] = useState(0);
  // const allData = formControllers.map(form => form.getValues());
  
  const data = JSON.parse(localStorage.getItem("okta-token-storage"));

  if (!gpid && data?.accessToken?.claims?.gpid) {
    setGpid(data.accessToken.claims.gpid);
  }

  if (!reqGpid && uid) {
    setReqGpid(uid);
  }


  useEffect(() => {
    const currentAttributes = attributes[selectedIndex];
    if (!currentAttributes) return;

    currentAttributes.forEach((attr) => {
      if (!attr || !attr.attribute_id) return;
      console.log('11111111111111111',attr?.prepop);
      const value = formData[selectedIndex]?.[attr.attribute_id]?.attributevalue
      || "";
      setValue(attr.attribute_id.toString(), value);
    });

    setFormKey(Date.now()); // Force re-render
  }, [formData, selectedIndex,setValue]);

  // const formControllers = selectedId.map(() => useForm());

  useEffect(() => {
    console.log("selectedId:", selectedId);

    if (Array.isArray(selectedId) && selectedId.length > 0) {
      selectedId.forEach((obj) => {
        obj.requestType = modeType;
      });

      console.log("Updated selectedId:", selectedId);

      formObjecct.appName = selectedId[selectedIndex]?.label || "";
      formObjecct.appId = selectedId[selectedIndex]?.id || "";
    }

    getDynamicFields();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [modeType]);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(requestNumber)
      .then(() => {
        setCopyButtonText("Copied");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const selectedRightTab = (index) => {
    setSelectedRightTabIndex(index);
  };

  const transformAttributes = (data) => {
    const app_form =
      data.formData.app_form != null
        ? data.formData.app_form
        : formData[selectedIndex].formData.app_form;
    const AppID = formData[selectedIndex]?.formData?.app_id
      ? formData[selectedIndex]?.formData?.app_id
      : data.formData.app_id;
    const formDataValue = data.formDataValue || {};
    const mandate = formDataValue.mandate || {};
    const editable = formDataValue.editable || {};
    const visible = formDataValue.visible || {};
    const infotext = formDataValue.infotext || {};
    const prepop = formDataValue.prepop || {};
    const select = formDataValue.select || {};
    const searchButton = formDataValue.searchButton || {};

    return app_form?.map((item) => {
      const attributeId = item.attribute_id;

      // Transform select options if available
      const transformedOptions = select[attributeId]
        ? select[attributeId].map((option) => ({
            id: option.value,
            displayText: option.text,
          }))
        : null;

      // Preserve existing attributeOptions if new ones are not available
      const existingAttr =
        attributes?.[selectedIndex]?.find(
          (attr) => attr.attribute_id === attributeId
        ) || {};
  
      // Enhanced prepop logic: map raw value to select option object
      
      const transformedOptions1 = Array.isArray(item.attributeOptions)
        ? item.attributeOptions
        : [];

      const prepopValue = prepop[attributeId];

    // const prepopValue = Array.isArray(prepopValueRaw)
    //   ? prepopValueRaw
    //       .map((id) => transformedOptions1.find((opt) => opt.id === id))
    //       .filter(Boolean)
    //   : prepopValueRaw
    //   ? transformedOptions1.find((opt) => opt.id === prepopValueRaw) || null
    //   : null;
      // console.log('9999999999999', attributeId, prepopValueRaw,select[attributeId],prepopValue, transformedOptions);
  
      return {
        ...item,
        mandate: mandate[attributeId] ?? null,
        editable: editable[attributeId] ?? null,
        visible: visible[attributeId] ?? null,
        infoapptext: infotext[AppID] ?? null,
        infotext: infotext[attributeId] ?? null,
        prepop: prepop[attributeId] ?? null,
        searchButton: searchButton[attributeId] ?? null,
        attributeOptions:
          transformedOptions ?? existingAttr.attributeOptions ?? null,
        attributeName: item.attribute_display_value,
        attributeID: attributeId,
        attributevalue:
      selectedId[selectedIndex]?.requestType === "MODIFY" ||
      selectedId[selectedIndex]?.requestType === "DISABLE"
        ? transformedOptions
          ? Array.isArray(item.attribute_value)
            // If already an array, map each id to option object
            ? item.attribute_value.map(id =>
                transformedOptions.find(opt => opt.id === id)
              ).filter(Boolean)
            // If comma-separated string, split and map
            : typeof item.attribute_value === 'string' && item.attribute_value.includes(',')
              ? item.attribute_value.split(',').map(id =>
                  transformedOptions.find(opt => opt.id === id.trim())
                ).filter(Boolean)
              // Single value case
              : transformedOptions.find(x => x.id === item.attribute_value)
          : item.attribute_value
        : null,
        attributeHelpText: item?.attribute_help_text,
        attributeDisplayOrder: item?.attribute_display_order,
        attributeType: item.type || "textarea",
        isRequired: !!mandate[attributeId],
      };
    });
  };

  const getDynamicFields = async () => {
    try {
      showLoader();

      const responses = await Promise.all(
        selectedId.map(async (item) => {
          const formObject = {
            appName: item.label,
            appId: item.id,
            triggeringField: "onload",
            stage: "0",
            requestType: item.requestType,
            requestedForGpid: reqGpid ? reqGpid : gpid,
            requestedByGpid: gpid,
            pepManager: "10000836",
            lang: "en",
            form: {},
            isOnChange: false,
          };

          if (item.requestType === "NEW") {
            return await requestsService.getFormData(formObject);
          } else if (item.requestType === "MODIFY") {
            return await requestsService.getModifiedFormData(formObject);
          } else if (item.requestType === "DISABLE") {
            return await requestsService.getDisableFormData(formObject);
          }
        })
      );
      console.log("22222222222222222", responses);

      const transformedResponses = responses.map((response, index) => {
        if (response?.data?.status === "Failed") {
          // showToast("index", response?.data?.errorMessage, "error");
          toast.error(response?.data?.errorMessage)
          return null;
        }

        const transformedData = transformAttributes(response);
        console.log("2222222222222", transformedData);
        const orderedTransformedData = transformedData.sort(
          (a, b) => a.attributeDisplayOrder - b.attributeDisplayOrder
        );

        orderedTransformedData.forEach((attr) => {
          control.register(attr.attribute_id.toString());
        });
        console.log("3224242244", selectedId[index]?.requestType);

        if (selectedId[index]?.requestType !== "NEW") {
          console.log("4343434343");

          // orderedTransformedData.forEach(attr => {
          //   console.log('999999999999999999',attr.attributevalue['id'],attr.attributeType);

          //   setValue(attr.attribute_id.toString(), attr.attributevalue ?? (attr.attributeType === "select" ? attr.attributevalue : []));
          // });

          orderedTransformedData.forEach((attr) => {
            const fieldName = `form_${index}.${attr.attribute_id}`;
            const isMultiSelect = attr.attributeType === "multiselect";
            const isSelect = attr.attributeType === "select";
          
            let valueToSet;
          
            if (isMultiSelect) {
              if (typeof attr.attributevalue === 'string') {
                // Handles both single and comma-separated values
                const selectedIds = attr.attributevalue.split(',').map(id => id.trim());
                valueToSet = attr.attributeOptions
                  ? attr.attributeOptions.filter(opt => selectedIds.includes(opt.id))
                  : [];
              } else if (Array.isArray(attr.attributevalue)) {
                // Already an array of option objects or IDs
                // If array of IDs, map to option objects
                if (attr.attributeOptions && typeof attr.attributevalue[0] === 'string') {
                  valueToSet = attr.attributeOptions.filter(opt => attr.attributevalue.includes(opt.id));
                } else {
                  valueToSet = attr.attributevalue;
                }
              } else if (attr.attributevalue && typeof attr.attributevalue.id === 'string') {
                // Single object with id property
                valueToSet = attr.attributeOptions
                  ? attr.attributeOptions.filter(opt => opt.id === attr.attributevalue.id)
                  : [];
              } else {
                valueToSet = [];
              }
            } else if (isSelect) {
              // Single select: always array of one option object if found
              if (typeof attr.attributevalue === 'string') {
                valueToSet = attr.attributeOptions
                  ? [attr.attributeOptions.find(opt => opt.id === attr.attributevalue)].filter(Boolean)
                  : [];
              } else if (attr.attributevalue && typeof attr.attributevalue.id === 'string') {
                valueToSet = [attr.attributevalue];
              } else {
                valueToSet = [];
              }
            } else {
              // Text, textarea, etc.
              valueToSet = attr.attributevalue ?? "";
            }
          
            setValue(fieldName, valueToSet);
          });
        }
        
        return {
          raw: response,
          transformed: orderedTransformedData,
        };
      });

      setFormData(transformedResponses.map((r) => r?.raw));
      setAttributes(transformedResponses.map((r) => r?.transformed));
      console.log("111111111111111", transformedResponses);
    } catch (error) {
      hideLoader();
      // showToast(
      //   1,
      //   error?.response?.data?.errorMessage || "Error fetching form data",
      //   "error"
      // );
      toast.error(error?.response?.data?.errorMessage || "Error fetching form data");
    } finally {
      hideLoader();
    }
    console.log("111111111111", attributes);
  };
  
  function stripHtml(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }
  
  const onFieldChange = (attributeId, value) => {
    const currentApp = selectedId?.[selectedIndex];
    const currentFormData = formData?.[selectedIndex];

    if (!currentApp || !currentFormData?.formData) {
      console.warn("Missing currentApp or currentFormData");
      return;
    }

    const allValues = watch() || {};
    const currentFormValues = { ...(allValues[`form_${selectedIndex}`] || {}) };

    const updatedFormValues = {
      ...currentFormValues,
      [attributeId]: value,
    };

    const updatedAppForm = buildUpdatedAppForm(
      currentFormData.formData.app_form,
      updatedFormValues
    );

    const updatedData = buildApiPayload(
      attributeId,
      currentApp,
      updatedAppForm
    );
    axios
      .post(`${REACT_APP_API_ENDPOINT}arfw/getFormData`, updatedData)
      .then((response) => {
        if (response?.data?.status === "Failed") {
          // showToast("index", response?.data?.errorMessage, "error");
          toast.error(response?.data?.errorMessage)
          return null;
        }
        const transformedData = transformAttributes(response.data);
        console.log('999999999999999',transformedData);
        
        const orderedTransformedData = sortAttributes(transformedData);
        orderedTransformedData.forEach((attr) => {
          if (!attr || !attr.attribute_id) return;
        
          // Only for select/multiselect
          if (
            (attr.attributeType === "select" || attr.attributeType === "multiselect") &&
            Array.isArray(attr.attributeOptions)
          ) {
            let valueToSet = null;
            const prepop = attr.prepop;
        
            if (prepop) {
              if (Array.isArray(prepop)) {
                // Multi-select: map each id to option object
                valueToSet = prepop
                  .map((id) => attr.attributeOptions.find((opt) => opt.id === id))
                  .filter(Boolean);
              } else {
                // Single select: find option object
                valueToSet = attr.attributeOptions.find((opt) => opt.id === prepop) || null;
              }
            }
        
            attr.attributevalue = valueToSet;
            setValue(attr.attribute_id.toString(), valueToSet);
            console.log("Set value for", attr.attribute_id, valueToSet);
          }
        });
        setTimeout(() => {
          updateAttributesState(orderedTransformedData);
          setFormKey((prevKey) => prevKey + 1);
        }, 1000);
      })
      .catch((error) => {
        console.error("Error fetching form details:", error);
        // showToast(1, error?.message || String(error), "error");
        toast.error(error?.message || String(error))
      });
  };

  const buildUpdatedAppForm = (appFormArray, updatedFormValues) => {
    const formArray = Array.isArray(appFormArray) ? appFormArray : [];

    return formArray.map((attr) => {
      const fieldValue = updatedFormValues?.[attr.attribute_id];
      let attribute_value = "";

      if (Array.isArray(fieldValue)) {
        attribute_value = fieldValue
          .map((item) => item?.id)
          .filter(Boolean)
          .join(",");
      } else if (typeof fieldValue === "object" && fieldValue?.id) {
        attribute_value = fieldValue.id;
      } else {
        attribute_value = fieldValue || "";
      }

      return {
        attribute_id: attr.attribute_id?.toString() || "",
        attribute_name: attr.attribute_name || "",
        attribute_value,
      };
    });
  };

  const buildApiPayload = (attributeId, currentApp, updatedAppForm) => ({
    triggeringField: attributeId,
    stage: "0",
    requestType: currentApp.requestType || "",
    requestedForGpid: reqGpid ? reqGpid : gpid,
    requestedByGpid: gpid,
    pepManager: "10000836",
    lang: "en",
    form: {
      app_id: `APP_${currentApp.id}`,
      app_form: updatedAppForm,
    },
    isOnChange: true,
    appId: `APP_${currentApp.id}`,
    appName: currentApp.label || "",
  });

  const sortAttributes = (attributes) => {
    return Array.isArray(attributes)
      ? attributes.sort(
          (a, b) => a?.attributeDisplayOrder - b?.attributeDisplayOrder
        )
      : [];
  };

  const updateAttributesState = (orderedTransformedData) => {
    setAttributes((prev) => {
      const updated = Array.isArray(prev) ? prev.slice() : [];

    const existingAttributes = Array.isArray(updated[selectedIndex])
      ? updated[selectedIndex].map(item => ({ ...item })) // clone to prevent mutation
      : [];

    // Normalize incoming, build map by id for O(1) lookup
    const incomingById = new Map(
      (Array.isArray(orderedTransformedData) ? orderedTransformedData : []).map(
        (attr) => [String(attr.attribute_id), attr]
      )
    );

    // Fields we want to *protect* from empty overwrites
    const PROTECT_FIELDS = new Set(['attributevalue', 'prepop']);

    // Helper: shallow merge that skips null/undefined/"" for protected fields
    const mergeWithProtection = (base, patch) => {
      const out = { ...base };
      for (const [k, v] of Object.entries(patch)) {
        if (PROTECT_FIELDS.has(k)) {
          // skip if null/undefined/"" — preserve existing non-empty value
          if (v === null || v === undefined || v === '') continue;

          // if attributevalue is an object, also skip if it's an empty object
          if (k === 'attributevalue' && typeof v === 'object' && v !== null) {
            if (Object.keys(v).length === 0) continue;
          }
        }
        out[k] = v;
      }
      return out;
    };

    // 1) Merge existing items with incoming (protecting fields)
    const merged = existingAttributes.map((existingAttr) => {
      const newAttr = incomingById.get(String(existingAttr.attribute_id));
      return newAttr ? mergeWithProtection(existingAttr, newAttr) : existingAttr;
    });

    // 2) Compute new-only items (normalize id types)
    const mergedIds = new Set(merged.map(a => String(a.attribute_id)));
    const newOnly = (Array.isArray(orderedTransformedData) ? orderedTransformedData : [])
      .filter((newAttr) => !mergedIds.has(String(newAttr.attribute_id)))
      .map(a => ({ ...a })); // clone incoming

    // 3) Build final list *unique by id* (avoid duplicates)
    const finalById = new Map();
    // start with merged (prefer merged values)
    merged.forEach(item => finalById.set(String(item.attribute_id), item));
    // add newOnly only if not already present
    newOnly.forEach(item => {
      const id = String(item.attribute_id);
      if (!finalById.has(id)) finalById.set(id, item);
    });

    updated[selectedIndex] = Array.from(finalById.values());
    return updated;
  });
};




  

  // Collect errors for each application/tab
  const tabErrors = {};
  const errorSummary = selectedId?.map((app, appIndex) => {
    const tabErrorsForForm = errors[`form_${appIndex}`] || {};
    const errorFields = Object.keys(tabErrorsForForm);

    // Track tab error status
    if (errorFields.length > 0) {
      tabErrors[appIndex] = true;
    }

    return {
      appName: app.label,
      errorCount: errorFields.length,
      errorFields,
    };
  });
 
  const totalErrors = errorSummary.reduce((acc, curr) => acc + curr.errorCount, 0);
  useEffect(() => {
    if (showNotification && totalErrors > 0 && notificationRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showNotification, totalErrors])
  const formValues = watch();
  // useEffect(() => {
  //   const currentAttributes = attributes[selectedIndex];
  //   if (!currentAttributes) return;
  //   currentAttributes.forEach((attr) => {
  //     if (!attr || !attr.attribute_id) return;
  //     const fieldName = `form_${selectedIndex}.${attr.attribute_id}`;
  //     const isMultiSelect = attr.attributeType === "multiselect";
  //     const isSelect = attr.attributeType === "select";
  
  //     let valueToSet = null;
  //     if (isMultiSelect) {
  //       valueToSet = Array.isArray(attr.attributevalue) ? attr.attributevalue : [];
  //     } else if (isSelect) {
  //       valueToSet = attr.attributevalue || null;
  //     } else {
  //       valueToSet = attr.attributevalue ?? "";
  //     }
  //     setValue(fieldName, valueToSet);
  //     console.log("Set value for", fieldName, valueToSet);
  //   });
  //   setFormKey(Date.now());
  // }, [attributes, selectedIndex, setValue]);
  const isInitialRender = useRef(true);
  useEffect(() => {
    
    console.log("999999999999attribute", attributes);
    if (isInitialRender.current) {
      attributes?.forEach((attr) => {
        control.register(attr?.attribute_id?.toString());
      });

    if (attributes && selectedId[selectedIndex]?.requestType !== "NEW") {
      attributes.forEach((attr) => {
        console.log('99999999999999999',attr);
        
        setValue(
          attr?.attribute_id?.toString(),
          attr?.attributevalue ??
            (attr?.attributeType === "select" ? attr?.attributevalue : [])
        );
      });
    }
    if (attributes && selectedId[selectedIndex]?.requestType == "NEW") {
      attributes.forEach((attr) => {
        console.log('99999999999999999',attr);
        
        setValue(
          attr?.attribute_id?.toString(),
          attr?.attributevalue ??
            (attr?.attributeType === "select" ? attr?.attributevalue : [])
        );
      });
    }
    }
  }, [selectedId]);
  const requestType = selectedId[selectedIndex]?.requestType;
  const formattedRequestType = requestType
  ? requestType.charAt(0).toUpperCase() + requestType.slice(1).toLowerCase()
  : '';
  useEffect(() => {
    if (!pendingFieldChange) return;

    const { attributeId, value } = pendingFieldChange;

    const currentApp = selectedId?.[selectedIndex];
    const currentFormData = formData?.[selectedIndex];

    if (!currentApp || !currentFormData?.formData) {
      console.warn("Missing currentApp or currentFormData");
      return;
    }

    const allValues = watch() || {};
    const currentFormValues = { ...(allValues[`form_${selectedIndex}`] || {}) };

    const updatedFormValues = {
      ...currentFormValues,
      [attributeId]: value,
    };

    const updatedAppForm = buildUpdatedAppForm(
      currentFormData.formData.app_form,
      updatedFormValues
    );
    const updatedData = buildApiPayload(
      attributeId,
      currentApp,
      updatedAppForm
    );

    axios
      .post(`${REACT_APP_API_ENDPOINT}arfw/getFormData`, updatedData)
      .then((response) => {
        if (response?.data?.status === "Failed") {
          // showToast("index", response?.data?.errorMessage, "error");
          toast.error(response?.data?.errorMessage)
          return null;
        }
        const transformedData = transformAttributes(response.data);
        const orderedTransformedData = sortAttributes(transformedData);
        console.log('8888888888888',orderedTransformedData);
        orderedTransformedData.forEach((attr) => {
          if (!attr || !attr.attribute_id) return;
          // Only for select/multiselect
          if (
            (attr.attributeType === "select" || attr.attributeType === "multiselect") &&
            Array.isArray(attr.attributeOptions)
          ) {
            let valueToSet = null;
            const prepop = attr.prepop;
            console.log('767676767',prepop);
            if (prepop) {
              if (Array.isArray(prepop)) {
                // Multi-select: map each id to option object
                valueToSet = prepop
                  .map((id) => attr.attributeOptions.find((opt) => opt.id === id))
                  .filter(Boolean);
              } else {
                console.log('767676767',prepop);
                
                // Single select: find option object
                valueToSet = attr.attributeOptions.find((opt) => opt.id === prepop) || null;
                console.log('12121212',valueToSet);
              }
            }
        
            attr.attributevalue = valueToSet;
            setValue(attr.attribute_id.toString(), valueToSet);
            console.log("Set value for", attr.attribute_id, valueToSet);
          }
        });
        orderedTransformedData.forEach((attr) => {
          if (!attr || !attr.attribute_id) return;
          const fieldName = `form_${selectedIndex}.${attr.attribute_id}`;
          if (!getValues(fieldName)) {
          let valueToSet = null;
          let valueattribute = null;
          let valueattributehelpText = null;
        
          if (attr.attributeType === "select" || attr.attributeType === "multiselect") {
            let rawValue = attr.prepop;
            console.log('11111111111111',rawValue);
            
            if (rawValue) {
              if (Array.isArray(rawValue)) {
                valueToSet = rawValue
                  .map((id) => attr.attributeOptions?.find((opt) => String(opt.id) === String(id)))
                  .filter(Boolean);
              } else {
                valueToSet = attr.attributeOptions?.find((opt) => String(opt.id) === String(rawValue)) || null;
              }
            }
        
            // Ensure correct type for Dropdown
            if (attr.attributeType === "multiselect") {
              valueToSet = valueToSet ? [valueToSet] : null;
            }else if(attr.attributeType === "select"){
              valueToSet = valueToSet ? [valueToSet] : null;
            } 
            else {
              valueToSet = valueToSet || null;
            }
            // console.log('222222222',valueToSet);
            // valueattribute = attr.attributeName.replace(/\//g, "");
            // valueattributehelpText = attr.attribute_help_text_display_value.replace(/\//g, "") 
            // attr.attributeName = valueattribute;
            attr.attributevalue = valueToSet;
            attr.attribute_value = valueToSet;
            // attr.attribute_help_text_display_value = valueattributehelpText;
            
            setValue(fieldName, valueToSet);
            console.log("Set value for", fieldName, valueToSet, attr.attributeOptions);
            
          }
        }
        });
        console.log('767676767676',formValues);
        console.log('99999999999',orderedTransformedData);
        orderedTransformedData.forEach((attr) => {
          if (!attr || !attr.attribute_id) return;
          if (attr.attributeType !== 'select' && attr.attributeType !== 'multiselect') return;
        
          const fieldName = `form_${selectedIndex}`;
          const rawValue = formValues[fieldName]?.[attr.attribute_id];

          const validIdSet = new Set(
            (attr.attributeOptions ?? []).map(opt => String(opt.id))
          );

          let valueToSet;

          if (Array.isArray(rawValue)) {
            const validValues = rawValue.filter(item => validIdSet.has(String(item?.id)));
            valueToSet = validValues.length > 0 ? validValues : [];
          } else if (rawValue && typeof rawValue === 'object') {
            valueToSet = validIdSet.has(String(rawValue.id)) ? rawValue : null;
          } else {
            valueToSet = attr.attributeType === 'multiselect' ? [] : null;
          }

          console.log('Updating values via setValue:', { attrId: attr.attribute_id, valueToSet });

          // Update RHF store
          setValue(`${fieldName}.${attr.attribute_id}`, valueToSet);

          // If you keep a local mirror on attr:
          attr.attributevalue = valueToSet;
        });

        console.log('after resetting the filters',orderedTransformedData);
        
        
          // if (attributes && selectedId[selectedIndex]?.requestType === "NEW") {
          //   const currentAttributes = attributes[selectedIndex] || [];
          //   currentAttributes.forEach(attr => {
          //     control.register(`form_${selectedIndex}.${attr.attribute_id}`);
        
          //     let valueToSet = null;
          //     if (attr.attribute_id === attributeId) {
          //       // Set the value to the selected option object or array
          //       valueToSet = value;
          //     } else if (attr.attributeType === "multiselect") {
          //       valueToSet = Array.isArray(attr.prepop)
          //         ? attr.prepop.map(id => attr.attributeOptions.find(opt => String(opt.id) === String(id))).filter(Boolean)
          //         : [];
          //     } else if (attr.attributeType === "select") {
          //       valueToSet = attr.attributeOptions.find(opt => String(opt.id) === String(attr.prepop)) || [];
          //     } else {
          //       valueToSet = attr.prepop ?? "";
          //     }
              
          //     setValue(`form_${selectedIndex}.${attr.attribute_id}`, valueToSet);
            
          //   });
        
            
          // }
        
        updateAttributesState(orderedTransformedData);
        console.log('after setting attributes',attributes);
        
        setFormKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        console.error("Error fetching form details:", error);
        // showToast(1, error?.message || String(error), "error");
        toast.error(error?.message || String(error))
      });
    setFormKey(Date.now());
    setPendingFieldChange(null); // reset after processing
  }, [pendingFieldChange, watch(), attributes, selectedIndex, setValue, control, selectedId]);

  useEffect(() => {
    if (attributes) {
        attributes?.selectedIndex?.forEach(attr => {
            setValue(attr.attribute_id, attr.attributevalue ?? (attr.attributeType === "select" ? attr.attributevalue : []));
        });
    }
  }, [attributes?.selectedIndex]);

  const setAccessRequestSelection = () => {
    setSelectRequest({ resetSelection: true });
    console.log("Back button clicked, resetting selection");
  };

  const labels = selectedId.map((item) => item.label);

  
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const onFormSubmit = async (data) => {
  try {
    showLoader();

    const applications = selectedId.map((app, index) => {
      const currentFormData = formData?.[index]?.formData?.app_form || [];
      const currentFormDataValue = formData?.[index]?.formDataValue?.visible;

      // If you later need visibility filtering, re-enable your block here
      let visibleAttributes = currentFormData;

      const attributes = visibleAttributes.map((attr) => {
        const fieldValue = data?.[`form_${index}`]?.[attr.attribute_id];

        let attributeValues = "";
        if (Array.isArray(fieldValue)) {
          attributeValues = fieldValue
            .map((item) => `${item.id}::${item.displayText}`)
            .join("$##$");
        } else if (typeof fieldValue === "object" && fieldValue?.id) {
          attributeValues = `${fieldValue.id}::${fieldValue.displayText}`;
        } else {
          attributeValues = fieldValue || "";
        }

          return {
            attributeID: attr.attribute_id?.toString(),
            attributeLabel: `${attr.attribute_name}::${attr.attribute_display_value}`,
            attributeValues,
            type: attr.type || "",
          };
        });

        return {
          formAttributes: { attributes },
          gpid: reqGpid ? reqGpid : gpid,
          appid: app?.id,
          formName: app?.label,
          requestType: app?.requestType,
        };
      });

      setCopyButtonText("Copy");

    const successfulRequests = [];
    const failedRequests = [];

    for (let i = 0; i < applications.length; i++) {
      const appData = applications[i];

      await sleep(150);

        const jsonData = {
          postApplicationsRequest: {
            application: [appData],
          },
        };

      let response;
      try {
        switch (appData.requestType) {
          case "NEW":
            response = await requestsService.submitFormRequest(jsonData);
            break;
          case "MODIFY":
            response = await requestsService.submitModifiedFormRequest(jsonData);
            break;
          case "DISABLE":
            response = await requestsService.submitDisableFormRequest(jsonData);
            break;
          default:
            response = { status: "Failed", errorMessage: "Unknown request type" };
        }
      } catch (err) {
        response = { status: "Failed", errorMessage: err?.message || "Network error" };
      }

      const appName = appData.formName;

      if (response?.status === "Success") {
        successfulRequests.push({
          appName,
          requestId: response?.requestId,
        });
        // You can defer this setState until after the loop to reduce re-renders.
        setSuccessfulRequestsList([...successfulRequests]);
        toast.success(`${appName}: ${response?.message}`);
      } else {
        failedRequests.push({
          appName,
          error: response?.errorMessage || "Unknown error",
        });
        toast.error(`${appName}: ${response?.errorMessage || "Unknown error"}`);
      }
    }

    if (successfulRequests.length > 0) {
      setRequestNumber(successfulRequests.map((r) => r.requestId).join(", "));
      setFormRequestSuccess(true);
    }
  } catch (error) {
    toast.error(error.message || "Error submitting form");
  } finally {
    hideLoader();
  }
};

  const [toasts, setToasts] = useState([]);
  const showToast = (index, message, type) => {
    setToasts([
      {
        id: `toast-${index}`,
        duration: 10000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  useEffect(() => {
    if (selectedIndex >= selectedId.length) {
      setSelectedIndex(selectedId.length - 1);
    }
  }, [selectedId]);
  
const handleCloseTab = (indexToRemove) => {
  const snapshot = getValues();

  const removedAttributes = attributes[indexToRemove] || [];
  removedAttributes.forEach((attr) => {
    unregister(`form_${indexToRemove}.${attr.attribute_id}`);
  });

  const updatedTabs = selectedId.filter((_, i) => i !== indexToRemove);
  setSelectedId(updatedTabs);

  setFormData(prev => prev.filter((_, i) => i !== indexToRemove));
  setAttributes(prev => prev.filter((_, i) => i !== indexToRemove));

  const nextValues = {};
  updatedTabs.forEach((_, newIndex) => {
    const oldIndex = newIndex >= indexToRemove ? newIndex + 1 : newIndex;
    nextValues[`form_${newIndex}`] = snapshot[`form_${oldIndex}`] || {};
  });

  reset(nextValues, { keepDirtyValues: true });

  setSelectedIndex((prev) => {
    if (prev > indexToRemove) return prev - 1; 
    if (prev === indexToRemove) return Math.max(0, prev - 1); 
    return prev; 
  });
};

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  return (
    <div
      className={!formRequestSuccess ? "w-100" : ""}
      style={{
        textAlign: "left",
        width: formRequestSuccess ? "auto !important" : "",
      }}
    >      
      {showNotification && totalErrors > 0 && ( 
      <div ref={notificationRef}>
      <Notification
        className=""
        secondaryActionLabel="X Close"
        secondaryActionOnClick={() => setShowNotification(false)}
        showActionButtons
        showIcon
        showText
        showTitle
        style={{marginTop:'-20px'}}
        text={`There are one or more errors in your form(s).Please review and resubmit.`}
        // title="Error Summary"
        type="error"
      />
      </div>
      )}
      {!formRequestSuccess && (
       <div 
       style={
           selectedId?.length > 1
             ? { display: 'flex', justifyContent: 'center' }
             : undefined
         }
       >

        {/* <TabsNavigation className="" selectedIndex={selectedIndex} style={{}}>
          {selectedId?.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              onClick={() => {
                setSelectedIndex(index);
                tab.onClick?.();
              }}
            />
          ))}
        </TabsNavigation> */}
        <TabsNavigation className="" selectedIndex={selectedIndex} style={{}}>
          {selectedId?.map((tab, index) => {
            const hasError = tabErrors[index]; // check if this tab has errors

            return (
              <Tab
                key={index}
                label={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: hasError ? 'red' : 'inherit', // highlight in red
                      fontWeight: hasError ? 'bold' : 'normal',
                    }}
                  >
                    <span>{tab.label}</span>
                    {selectedId?.length > 1 && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCloseTab(index);
                        }}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          color: '#999',
                          padding: 0,
                        }}
                        aria-label={`Close ${tab.label}`}
                      >
                        ×
                      </button>
                    )}
                  </div>
                }
                onClick={() => {
                  setSelectedIndex(index);
                  tab.onClick?.();
                }}
              />
            );
          })}
        </TabsNavigation>
      </div>
      )}
      {Array.isArray(attributes) &&
        attributes.map((formAttributes, index) => (
          <div
            id="arf-form-attributes"
            key={`form-${index}`}
            style={{ display: selectedIndex === index ? "block" : "none" }}
          >
            {!formRequestSuccess && (
              <form
                onSubmit={handleSubmit((data) => onFormSubmit(data, index))}
                noValidate
              >
                {formAttributes?.find((attr) => attr?.infoapptext) && (
                  <div
                    style={{
                      marginBottom: "1rem",
                      fontSize: "0.9rem",
                      color: "#6c757d",
                      backgroundColor: "#f8f9fa",
                      padding: "0.75rem",
                      borderRadius: "4px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formAttributes.find((attr) => attr?.infoapptext)
                        ?.infoapptext,
                    }}
                  />
                )}
                <div
                  className="arfw-layout"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                  }}
                >
                  {Array.isArray(formAttributes) &&
                    formAttributes.map((attr) => {
                      if (!attr?.visible) return null;

                      const errorMessage =
                        errors?.[`form_${index}`]?.[attr.attribute_id]?.message;
                      const helpText =
                        attr.attribute_help_text_display_value || "";

                      const commonProps = {
                        required: attr.isRequired,
                        isRequired: attr.isRequired,
                        disabled: !attr.editable,
                        error: !!errorMessage,
                      };
                      const renderLabelWithTooltip = (labelText) =>
                        helpText ? (
                          <Tooltip
                            direction="auto"
                            maxWidth="300px"
                            text={<span dangerouslySetInnerHTML={{ __html: helpText }} />}
                          >
                            <span dangerouslySetInnerHTML={{ __html: labelText }} />
                          </Tooltip>
                        ) : (
                          <span dangerouslySetInnerHTML={{ __html: labelText }} />
                        );

                      return (
                        <div
                          key={attr.attribute_id}
                          className="form-field"
                          style={{
                            display: (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical') ? "flex":'',
                            flexDirection: (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical') ? "column" :'',
                            flex: isMobile|| (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical') ? "none" :"1 1 calc(33% - 0.5rem)",
                            alignItems: isMobile || (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical')? "center" : "stretch",
                            maxWidth:isMobile || (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical') ? '100%' : 'calc(33% - 0.5rem)',
                            width :isMobile || (selectedId[selectedIndex]?.pepAppViewType.toLowerCase() == 'vertical') ? '100%' : 'none',
                            marginBottom: "1rem",
                          }}
                        >
                          <Controller
                            name={`form_${index}.${attr.attribute_id}`}
                            control={control}
                            rules={{
                              required: attr.isRequired
                                ? "This field is required"
                                : false,
                            }}
                            render={({ field }) => {
                              
                              // Log the current value and options before rendering
                              console.log('Dropdown :attr.attribute_display_value', attr.attribute_display_value);
                              console.log('Dropdown field.value:', field.value);
                              console.log('Dropdown attr.attributeOptions:', attr.attributeOptions);

                              const renderField = () => {
                                switch (attr.attributeType) {
                                  case "select":
                                  case "multiselect":
                                    return (
                                      <>
                                        <Dropdown
                                          style={{maxWidth:"25rem"}}
                                          {...commonProps}
                                          showLabelIcon={false}
                                          label={renderLabelWithTooltip(attr.attribute_display_value)}
                                          selectedValue={
                                            attr?.attributeType === "multiselect"
                                              ? Array.isArray(field?.value) ? field.value : []
                                              : field?.value || null
                                          }
                                          helperText={
                                            selectedId[selectedIndex]?.requestType == "DISABLE" && attr.attributeType === "multiselect" && !attr.edit
                                              ? Array.isArray(field.value) && field.value.length > 1
                                                ? field.value.map(item => item.displayText).join(', ')
                                                : 'No options selected'
                                              : ''
                                          }
                                          childList={Array.isArray(attr.attributeOptions) ? attr.attributeOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); }) : []}
                                          setSelectedValue={value => {
                                            field.onChange(value); // value is the option object or array of option objects
                                            setPendingFieldChange({
                                              attributeId: attr.attribute_id,
                                              value,
                                            });
                                          }}
                                          isClearable={attr.editable}
                                          selection={attr.attributeType === "multiselect" ? "multiple" : undefined}
                                          onKeyDown={(e) => e.preventDefault()}
                                        />
                                        {attr.infotext && (
                                          <div
                                            style={{
                                              marginBottom: "0.5rem",
                                              fontSize: "0.85rem",
                                              color: "#6c757d",
                                            }}
                                          >
                                            <span dangerouslySetInnerHTML={{ __html: attr?.infotext }} />
                                            {/* {attr?.infotext} */}
                                          </div>
                                        )}
                                      </>
                                    );
                                  case "textarea":
                                    return (
                                      <>
                                        <TextArea
                                          {...commonProps}
                                          placeholder={
                                            stripHtml(attr.attribute_display_value)
                                          }
                                          label={renderLabelWithTooltip(
                                            attr.attributeName
                                          )}
                                          value={
                                            field.value ?? attr.prepop ?? ""
                                          }
                                          showLabelIcon={false}
                                          showToolbar = {false}
                                          maxLength={1000}
                                          onChange={(e) => {
                                            let value = e.target.value;
                                            field.onChange(e.target.value);
                                            // setPendingFieldChange({
                                            //   attributeId: attr.attribute_id,
                                            //   value,
                                            // });
                                          }}
                                          style={{
                                            width: "100%",
                                            height: "100px",
                                          }}
                                        />
                                        {attr.infotext && (
                                          <div
                                            style={{
                                              marginBottom: "0.5rem",
                                              fontSize: "0.85rem",
                                              color: "#6c757d",
                                            }}
                                          >
                                            <span dangerouslySetInnerHTML={{ __html: attr?.infotext }} />
                                          </div>
                                        )}
                                      </>
                                    );
                                  case "text":
                                    return (
                                      <>
                                        {attr.searchButton && (
                                          <Search
                                            {...commonProps}
                                            value={field.value ?? ""}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              field.onChange(value);
                                              onFieldChange(
                                                attr.attribute_id,
                                                value
                                              );
                                            }}
                                            placeholderText="Type a search keyword"
                                            size="medium"
                                          />
                                        )}
                                        {!attr.searchButton && (
                                          <TextInput
                                            {...commonProps}
                                            placeholderText={
                                              stripHtml(attr.attribute_display_value)
                                            }
                                            // label={renderLabelWithTooltip(
                                            //   attr.attribute_display_value
                                            // )}
                                            label={
                                              stripHtml(attr.attribute_display_value)
                                            }
                                            value={
                                              field.value ?? attr.prepop ?? ""
                                            }
                                            showLabelIcon={false}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              field.onChange(e.target.value);
                                              setPendingFieldChange({
                                                attributeId: attr.attribute_id,
                                                value,
                                              });
                                            }}
                                          />
                                        )}
                                        {attr.infotext && (
                                          <div
                                            style={{
                                              marginBottom: "0.5rem",
                                              fontSize: "0.85rem",
                                              color: "#6c757d",
                                            }}
                                          >
                                            <span dangerouslySetInnerHTML={{ __html: attr?.infotext }} />
                                          </div>
                                        )}
                                      </>
                                    );
                                  default:
                                    return null;
                                }
                              };

                              return (
                                <>
                                  {renderField()}
                                  {errorMessage && (
                                    <span
                                      className="error"
                                      style={{
                                        color: "#dc3545",
                                        fontSize: "0.85rem",
                                      }}
                                    >
                                      {errorMessage}
                                    </span>
                                  )}
                                </>
                              );
                            }}
                          />
                        </div>
                      );
                    })}
                </div>

                <hr className="custom-hr" />
                <div
                  style={{ gap: "8px", justifyContent: "flex-end" }}
                  className="d-flex mt-4"
                >
                  <Button
                    type="button"
                    size="medium"
                    text={t('RequestNewAccessForSelf.cancel')}
                    variant="tertiary"
                    onClick={setAccessRequestSelection}
                  />
                  <Button type="submit" size="medium">
                  {t('RequestNewAccessForSelf.submit_request')}
                  </Button>
                </div>
              </form>
            )}
          </div>
        ))}
      <div>
        <Modal
          auxiliaryButtonProps={null}
          className=""
          linkProps={null}
          closeOnOutsideClick={false}
          notificationsProps={null}
          showModal={formRequestSuccess}
          onCloseModal= {(e) =>{
            e.preventDefault()
            gotoRequestPage()}}
          primaryButtonProps={{
          onClick: () =>gotoRequestAuditPage(),
          size: 'medium',
          text: t('RequestNewAccessForSelf.view_requets'),
          variant: 'primary'
          }}
          secondaryButtonProps={{
            onClick: (e) => {
              e.preventDefault()
              gotoRequestPage()},
            size: 'medium',
            text: t('RequestNewAccessForSelf.back'),
            variant: 'teritory'
            }}
          showAuxiliaryButton
          showLink
          showPrimaryButton
          style={{width:'350px'}}
          tertiaryButtonProps={null}
          type="fluid"
          viewPort={"mobile"}
          >
            <div className="search-division" id="searchbydivision" style={{minWidth:'95%'}}>
            <h5 className="modal-header-text">{formattedRequestType} {t('RequestNewAccessForSelf.confirm_access')}</h5>
            {/* <p style={{fontSize:'12px'}}>Should we submit a request to {formattedRequestType} access for this application?</p> */}
            <p style={{fontSize:'14px'}} className="modal-para-text mb-2">{t('RequestNewAccessForSelf.ticket_number_text')}: {requestNumber}. {t('RequestNewAccessForSelf.save_number')} 
            </p>
            <p style={{fontSize:'14px'}} className="modal-para-text mb-2">
            {t('RequestNewAccessForSelf.requested_to')} {formattedRequestType}  {t('RequestNewAccessForSelf.access_for')}  
            </p>
            <div className="accountsAlign mb-2">
                {successfulRequestsList?.map((apps, index) => (
                  <span
                    key={index}
                    className="endPointInfo"
                    style={{marginLeft: '8px' }}
                  >
                    {apps?.appName}
                  </span>
                ))}
              </div>
            <Notification
              primaryActionLabel={copyButtonText}
              primaryActionOnClick={copyToClipboard}
              text={requestNumber}
              title={t('RequestNewAccessForSelf.ticket_number')}
              type="info"
            />
            <p style={{fontSize:'14px'}} className="modal-para-text mb-2">{t('RequestNewAccessForSelf.view_all_requests')}</p>
            </div>
                  
        </Modal>
      </div>

      <ToastContainer
        position="bottom-center"
        data={toasts}
        removeToast={removeToast}
      />

      {/* {formRequestSuccess && (
        <div>
          <div className="card-content" style={{ width: "auto" }}>
            <h1>Congratulations</h1>
            <div className="info-container">
              <p>Form Request has been successfully Submitted.</p>
            </div>
            <hr className="custom-hr" />
            <Notification
              primaryActionLabel={copyButtonText}
              primaryActionOnClick={copyToClipboard}
              text={requestNumber}
              title="Ticket number"
              type="info"
            />
            <div className="powd_success_background"></div>
            <Button
              className="full-button"
              size="medium"
              onClick={setAccessRequestSelection}
            >
              Request another access
            </Button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ArfFormAttributes;
